import { Customer, Invoice } from '@thro-types/billing';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

import { useInvoiceMutation } from 'api/hooks/billing/invoices';
import CreatePage from 'app/components/CreatePage';
import { AlertActions } from 'app/containers/Dashboard/Alert/slice';
import { translations } from 'locales/i18n';
import usePageHeading from 'utils/hooks/usePageHeading';

import { CreateBody } from './components/CreateBody';
import { invoiceInitialValues, invoiceValidationSchema } from './validation';

export const InvoiceCreate = () => {
  const { creation } = useInvoiceMutation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const [disabledCancel, setDisabledCancel] = useState(false);

  usePageHeading({
    heading: t(translations.pages.billing.invoiceCreate.title()),
    headingProps: { back: location.state?.back ?? '/billing' }
  });

  const handleSubmit = async values => {
    if (submitting) {
      return;
    }

    setSubmitting(true);
    setDisabledCancel(true);
    try {
      const response = await creation.mutateAsync({
        ...values,
        invoiceArticles: []
      });
      dispatch(
        AlertActions.success(t(translations.pages.billing.alerts.successfulInvoiceCreate()))
      );
      navigate(`/billing/invoices/${response.id}`, { state: { editMode: true } });
    } catch (error) {
      dispatch(AlertActions.error(t(translations.pages.billing.alerts.failedInvoiceCreate())));
    } finally {
      setSubmitting(false);
      setDisabledCancel(false);
    }
  };
  return (
    <CreatePage<Invoice & { customer: Customer }>
      handleSaveClick={handleSubmit}
      initialValues={invoiceInitialValues(undefined)}
      submittingState={[submitting, setSubmitting]}
      disabledCancel={disabledCancel}
      validationSchema={invoiceValidationSchema}
    >
      {() => <CreateBody />}
    </CreatePage>
  );
};
